import React, { useCallback, useEffect, useState } from "react";

import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDropzone } from "react-dropzone";
import ProgressBar from "react-progressbar";
import { useSelector } from "react-redux";

import { fileUploadSource } from "../helpers/Sources/createSource";
import "./step.css";
import SwalAlertComp from "./SwalAlert";

const FileUploadComponent = ({
    source_type,
    buttonClicked,
    handleGetSources,
    getAllSourcesReduxProps,
    sourceFileID,
    setFileData,
    domain,
    file,
    setFile,
    setFileDomain,
    setFileUploadDomain,
    setButtonClicked,
    tracker_id,
    selectFileSourceId,
    addToTracker,
    setIsLoading,
    isLoading,
    usage,
    setUsage,
    setSelectedLeadgenId,
    selectedLeadgenId,
    newFileCheck,
    sourceMappingCheck,
    setLoading,
}) => {
    const [progress, setProgress] = useState(0);
    const language = useSelector((state) => state.languagesState.languages);
    const onDrop = useCallback((acceptedFiles) => {
        setFile(acceptedFiles[0]);
    }, []);
    const handleFileDelete = () => {
        setFile(null);
    };
    const {
        acceptedFiles,
        getRootProps,
        getInputProps,
        isDragActive,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: ".csv",
        onProgress: function (e) {
            const progress = Math.round((100 * e.loaded) / e.total);
            setProgress(progress);
        },
    });

    const mappings = {
        lead_id: selectedLeadgenId?.leadgen_id || "none",
        lead_status: selectedLeadgenId?.leadStatus || "none",
        lead_date: selectedLeadgenId?.date || "none",
    };
    useEffect(() => {
        const fileUploadAsync = async () => {
            if (file && source_type && domain && buttonClicked) {
                setIsLoading && setIsLoading(true);
                const formData = new FormData();
                if (usage) {
                    usage.forEach((val) => {
                        if (typeof val !== "number") {
                            formData.append("usage_types[]", val?.id);
                        } else {
                            formData.append("usage_types[]", val);
                        }
                    });
                }

                formData.append("file", file);
                formData.append("source_type", source_type);
                formData.append("domain", domain);
                formData.append("mappings[lead_id]", mappings.lead_id);
                formData.append("mappings[lead_status]", mappings.lead_status);
                formData.append("mappings[lead_date]", mappings.lead_date);
                let response = await fileUploadSource(
                    formData,
                    sourceFileID && sourceFileID,
                );
                if (response.status) {
                    setIsLoading && setIsLoading(false);
                    if (sourceMappingCheck) {
                        sourceMappingCheck(
                            response.data && response.data.id,
                            "upload",
                            response.data && response.data.source_type_id,
                        );
                        setButtonClicked(false);
                    } else {
                        if (tracker_id) {
                            if (response.data && response.data.id) {
                                addToTracker(response.data.id);
                            }
                        }
                        if (setSelectedLeadgenId !== undefined) {
                            setSelectedLeadgenId({
                                leadgen_id: "",
                                leadStatus: "",
                                date: "",
                            });
                        }
                        if (setUsage !== undefined) {
                            setUsage([]);
                        }
                        if (isLoading) {
                            setIsLoading && setIsLoading(false);
                        }
                        if (setLoading) {
                            setLoading(false);
                        }
                        if (handleGetSources) {
                            handleGetSources();
                            setButtonClicked(false);
                        }
                        if (setFileData) {
                            setFile(null);
                            setFileData(false);
                            setFileUploadDomain("");
                            setButtonClicked(false);
                        }
                        if (getAllSourcesReduxProps) {
                            if (response.data && response.data.id) {
                                selectFileSourceId(
                                    response.data && response.data.id,
                                    response.data.source_type_id,
                                );
                            }
                            setFile(null);
                            setFileDomain("");
                            getAllSourcesReduxProps();
                            setButtonClicked(false);
                        }
                    }
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: response.message && response.message,
                        icon: "error",
                    });
                    if (isLoading) {
                        setIsLoading && setIsLoading(false);
                    }
                    if (tracker_id) {
                        setFile(null);
                        setButtonClicked(false);
                    }
                    if (handleGetSources) {
                        setButtonClicked(false);
                    }
                    if (setFileData) {
                        setFile(null);
                        setFileUploadDomain("");
                        setButtonClicked(false);
                        setFileData(false);
                    }
                    if (getAllSourcesReduxProps) {
                        setFile(null);
                        setFileDomain("");
                        setButtonClicked(false);
                    }
                }
            }
        };
        fileUploadAsync();
    }, [buttonClicked]);

    return (
        <div>
            <div
                className={`dropzone ${isDragActive ? "active" : ""} ${
                    isDragReject ? "rejected" : ""
                }`}
                {...getRootProps()}
            >
                <input
                    {...getInputProps({
                        "data-cy": "create-source-file-input",
                    })}
                />
                <p className="dropzone-text">
                    {isDragActive
                        ? (language?.sources_page?.drop_files_here ??
                          "Drop files here")
                        : (language?.sources_page
                              ?.drop_file_here_click_upload ??
                          "Drop file here or click to upload")}
                </p>
                {isDragReject && (
                    <p className="dropzone-text">
                        {language?.sources_page?.you_upload_cvs_files ??
                            "You can only upload CSV files"}
                    </p>
                )}
                {file && (
                    <p className="dropzone-text">
                        {language?.sources_page?.uploaded_file ??
                            "Uploaded file"}
                        : {file.name}{" "}
                        <span
                            className="delete-icon"
                            onClick={handleFileDelete}
                        >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </span>
                    </p>
                )}
            </div>
            {file && (
                <div className="progress-bar rounded-sm mt-2">
                    <ProgressBar completed={progress} />
                </div>
            )}
            <div className="py-3">
                <p>
                    {language?.sources_page?.click ?? "Click"}{" "}
                    <a
                        href={`${process.env.REACT_APP_PRO_MODE}/api/template/download/csv`}
                    >
                        <u>{language?.sources_page?.here ?? "here"}</u>
                    </a>{" "}
                    {language?.sources_page?.to_see_sample_file ??
                        "to see sample file."}
                </p>
            </div>
        </div>
    );
};

export default FileUploadComponent;
